export default __webpack_public_path__ + "static/media/36I-117164_-37344_0.330c8d45.jpg";